import { useEffect } from 'react';

const defaultTitle = 'Carvana® Purchase';

const useDocumentTitle = (title: string) => {
  useEffect(() => {
    document.title = title ? `${title} | ${defaultTitle}` : defaultTitle;
  }, [title]);
};

export default useDocumentTitle;